import CardPanel from './card-panel.vue'
export default CardPanel
